import React from 'react';
import moment from 'moment';
import {
  Modal,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Button,
  Spinner,
} from 'reactstrap';

const Line = ({ label, value }) => (
  <>
    <hr />
    <Row>
      <Col sm={6}>{label}</Col>
      <Col sm={6}>: {value}</Col>
    </Row>
  </>
);

/** "Add to GL Journal" confirmation. Open while `bank` (its details) is set. */
const AddToGlModal = ({
  bank,
  poCode,
  mutationDate,
  busy,
  onConfirm,
  onCancel,
}) => (
  <Modal isOpen={Boolean(bank)} toggle={onCancel} size="md" centered>
    <ModalBody>
      <div className="text-center">{`Are you sure want to add ${poCode}`}</div>
      <div className="text-center">to GL Journal with details</div>
      <div className="mt-4">
        <Container>
          <Line label="From Account Name" value={bank?.accountName} />
          <Line label="From Account Number" value={bank?.accountNumber} />
          <Line label="From Bank Name" value={bank?.bankName} />
          <Line
            label="Mutation Date"
            value={moment(mutationDate).format('DD/MM/YYYY')}
          />
          <hr />
        </Container>
      </div>
    </ModalBody>
    <ModalFooter>
      <Button
        color="success"
        style={{ backgroundColor: '#32b280' }}
        onClick={onConfirm}
      >
        {busy ? <Spinner size="sm" color="white" /> : 'Yes'}
      </Button>
      <Button color="danger" onClick={onCancel}>
        No
      </Button>
    </ModalFooter>
  </Modal>
);

export default AddToGlModal;
